var _path, _path2;
import * as React from "react";
import { SvgIcon } from '@mui/material';
const SvgShowerOff = props => /*#__PURE__*/React.createElement(SvgIcon, props, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.42 2.25L2 3.66l4.292 4.292A6.945 6.945 0 005 12v2h7.34l2.705 2.705a1.003 1.003 0 001.25 1.25l4.095 4.095 1.41-1.41L3.42 2.25zM10.34 12L7.733 9.393A4.975 4.975 0 007 12h3.34z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 12h-1.086l1.999 2H19v-2c0-3.53-2.61-6.43-6-6.92V3h-2v2.08a7 7 0 00-1.581.421l1.595 1.596A5.002 5.002 0 0117 12zM9 17c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1zM12 16c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM8 19c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM12 19c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM16 19c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
})));
export default SvgShowerOff;